// extracted by mini-css-extract-plugin
export default {"mainSlider":"FirstSlider_mainSlider__PKo6O","container":"FirstSlider_container__Kref2"};